import * as Highcharts from 'highcharts/highcharts';
import { BiospecimenInventoryLookup } from '../../secure/biospecimens/inventory-summary/scripts/inventory-lookup';
import { FormatNumberWithCommas } from '../../shared/scripts/number-functions';


// --- Test Data for Chart Structure Testing ---
//const testData = {
//    participantsByVisit: [2510, 945, 945, 1200, 998, 322, 25, 0],
//    samplesByVisit: [
//        [301, 56309, 44967, 3759, 4457],
//        [573, 62330, 50604, 0, 4766],
//        [0, 23094, 18309, 352, 1677],
//        [354, 26743, 21725, 1778, 2147],
//        [0, 24291, 19609, 471, 1789],
//        [0, 8170, 6536, 44, 597],
//        [33, 349, 232, 9, 76],
//        [0, 0, 0, 0, 0]
//    ],
//    unitsByVisit: [
//        [346, 56360, 45031, 7396, 4457],
//        [668, 62353, 50604, 0, 4766],
//        [0, 23094, 18309, 691, 1677],
//        [407, 26743, 21725, 3519, 2147],
//        [0, 24291, 19609, 928, 1789],
//        [0, 8170, 6536, 87, 597],
//        [118, 349, 232, 17, 76],
//        [0, 0, 0, 0, 0]
//    ],
//    participantsByTimepoint: [
//        [25, 674, 700, 914, 677],
//        [11, 559, 540, 1170, 549],
//        [55, 473, 471, 0, 483],
//        [12, 130, 119, 0, 150],
//        [0, 605, 613, 0, 561]
//    ],
//    totalParticipants: 2517,
//    totalSamples: 386451,
//    totalUnits: 393092
//};


export class InventorySummaryPublicPage {
    patientsByVisitChart: any;
    patientsBySampleType: any;
    samplesByVisitChart: any;
    unitsByVisitChart: any;

    colorArray: string[] = [
        "#013c58",
        "#457b9d",
        "#a8e8f9",
        "#b5c6e0",
        "#fdc500",
        "#ffe14c",
        "#fff2b2"
    ];

    collection_windows: string[] = [
        "Day0", "Days1to50", "Days51to75", "Days76to90",
        "Days91to168", "Days169to336", "Unscheduled"
    ];

    constructor(precomputedData: any) {
        Highcharts.setOptions({
            lang: { thousandsSep: ',' },
            colors: this.colorArray
        });

        $(() => {
            this.initializeParticipantsByVisitChart();
            this.initializeParticipantsBySampleTypeChart();
            this.samplesByVisitChart = this.initializeSamplesandUnitsByVisitChart('samples-byvisit-chart', 'Unique Collection');
            this.unitsByVisitChart = this.initializeSamplesandUnitsByVisitChart('units-byvisit-chart', 'Resulting Sample');

            this.updateDisplay(precomputedData);

            $('#loading-indicator').hide();
            $('.loaded-content').removeClass('invisible');
        });
    }

    reorderedData(originalData: number[]): number[] {
        const originalOrder = BiospecimenInventoryLookup.SAMPLE_TYPES;
        const alphabeticalOrder = BiospecimenInventoryLookup.GetAlphabeticalSampleTypes();
        return alphabeticalOrder.map(sampleType => {
            const originalIdx = originalOrder.indexOf(sampleType);
            return originalData[originalIdx] ?? 0;
        });
    }

    updateDisplay(precomputedData: any): void {
        $('#value-total-participants').text(FormatNumberWithCommas(precomputedData.totalParticipants + ""));
        $('#value-total-samples').text(FormatNumberWithCommas(precomputedData.totalSamples + ""));
        $('#value-total-units').text(FormatNumberWithCommas(precomputedData.totalUnits + ""));

        this.patientsByVisitChart.series[0].setData(precomputedData.participantsByVisit);

        for (let i = 0; i < precomputedData.samplesByVisit.length; i++) {
            this.samplesByVisitChart.series[i].setData(this.reorderedData(precomputedData.samplesByVisit[i]), false, true, false);
        }
        this.samplesByVisitChart.redraw();

        for (let i = 0; i < precomputedData.unitsByVisit.length; i++) {
            this.unitsByVisitChart.series[i].setData(this.reorderedData(precomputedData.unitsByVisit[i]), false, true, false);
        }
        this.unitsByVisitChart.redraw();

        //console.log("participantsByTimepoint length:", precomputedData.participantsByTimepoint.length);
        //console.log("patientsBySampleType series length:", this.patientsBySampleType.series.length);

        for (let i = 0; i < precomputedData.participantsByTimepoint.length; i++) {
            const seriesIndex = 5 - i;
            if (this.patientsBySampleType.series[seriesIndex]) {
                this.patientsBySampleType.series[seriesIndex].setData(
                    this.reorderedData(precomputedData.participantsByTimepoint[i]), false, true, false
                );
            } else {
                console.warn("Series index out of bounds:", seriesIndex);
            }
        }
        this.patientsBySampleType.redraw();


    }

    initializeParticipantsByVisitChart(): void {
        this.patientsByVisitChart = Highcharts.chart({
            chart: {
                renderTo: 'participants-byvisit-chart',
                type: 'bar'
            },
            colors: this.colorArray,
            credits: { enabled: false },
            title: { text: null },
            legend: { enabled: false },
            xAxis: {
                categories: [
                    "Day 0", "Days 1-50", "Days 51-75", "Days 76-90",
                    "Days 91-168", "Days 169-336", "Unscheduled", "Unknown"
                ],
                reversed: true,
                labels: { align: "left", reserveSpace: true },
                title: { text: 'Collection Windows' }
            },
            yAxis: {
                min: 0,
                endOnTick: false,
                maxPadding: 0.2,
                title: { text: 'Participant Count' },
                labels: {
                    formatter: function () {
                        return Highcharts.numberFormat(this.value, 0, '.', ',');
                    }
                }
            },
            tooltip: {
                enabled: true,
                borderColor: "black",
                useHTML: true,
                formatter: function () {
                    const xValue = String(this.x);
                    return `<b>${xValue.replace("<br>", " ")}</b><br/><div class="text-center">${Highcharts.numberFormat(this.y, 0, '.', ',')}</div>`;
                }
            },
            plotOptions: {
                bar: {
                    colorByPoint: true,
                    dataLabels: {
                        enabled: true,
                        crop: false,
                        overflow: 'justify',
                        allowOverlap: true,
                        formatter: function () {
                            return Highcharts.numberFormat(this.y, 0, '.', ',');
                        }
                    }
                }
            },
            series: [{
                type: 'bar',
                data: new Array(this.collection_windows.length).fill(0)
            }]
        });
    }

    initializeParticipantsBySampleTypeChart(): void {
        //const categories = BiospecimenInventoryLookup.SAMPLE_TYPES;
        const categories = BiospecimenInventoryLookup.GetAlphabeticalSampleTypes();
        const seriesData: Highcharts.SeriesBarOptions[] = [];
        for (let n = 6; n >= 1; n--) {
            seriesData.push({
                type: 'bar',
                name: `${n}`,
                data: new Array(categories.length).fill(0),
                color: this.colorArray[n - 1]
            });
        }

        this.patientsBySampleType = Highcharts.chart(
            'participants-bysampletype-chart',
            {
                chart: { type: 'bar' },
                credits: { enabled: false },
                title: { text: null },
                xAxis: {
                    type: 'category',
                    categories: categories,
                    title: { text: 'Biospecimen Types' },
                    min: 0,
                    max: categories.length - 1,
                    labels: { align: 'left', reserveSpace: true }
                },
                yAxis: {
                    min: 0,
                    //tickInterval: 600,
                    endOnTick: false,
                    maxPadding: 0.2,
                    title: { text: 'Participant Count' },
                    labels: {
                        formatter: function () {
                            return Highcharts.numberFormat(this.value as number, 0, '.', ',');
                        }
                    },
                    stackLabels: {
                        enabled: true,
                        formatter: function () {
                            return Highcharts.numberFormat((this as any).total as number, 0, '.', ',');
                        }
                    }
                },
                legend: {
                    reversed: true,
                    title: {
                        text: '<div style="font-size: 10px; color: #666; font-weight: normal; width: 100%; text-align: center">Number of Unique Collection Windows</div>'
                    },
                    align: 'center',
                    verticalAlign: 'top'
                },
                plotOptions: {
                    series: { stacking: 'normal' },
                    bar: { pointPadding: 0.2, borderWidth: 0, dataLabels: { enabled: false } }
                },
                series: seriesData
            }
        );
    }

    initializeSamplesandUnitsByVisitChart(chartId: string, label: string): any {
        return Highcharts.chart({
            chart: {
                renderTo: chartId,
                type: 'bar'
            },
            credits: { enabled: false },
            title: { text: null },
            xAxis: {
                type: 'category',
                //categories: BiospecimenInventoryLookup.SAMPLE_TYPES,
                categories: BiospecimenInventoryLookup.GetAlphabeticalSampleTypes(),
                title: { text: 'Biospecimen Types' },
                min: 0,
                //max: BiospecimenInventoryLookup.SAMPLE_TYPES.length - 1,
                max: BiospecimenInventoryLookup.GetAlphabeticalSampleTypes().length - 1,
                labels: { align: "left", reserveSpace: true }
            },
            yAxis: {
                min: 0,
                endOnTick: false,
                maxPadding: 0.2,
                reversedStacks: false,
                title: { text: label + ' Count' },
                labels: {
                    formatter: function () {
                        return Highcharts.numberFormat(this.value, 0, '.', ',');
                    }
                },
                stackLabels: {
                    enabled: true,
                    formatter: function () {
                        return Highcharts.numberFormat(this.total, 0, '.', ',');
                    }
                }
            },
            legend: {
                enabled: false,
                reversed: false,
                title: {
                    text: '<div style="font-size: 10px; color: #666; font-weight: normal; width: 100%; text-align: center">Visits</span>',
                },
                align: 'center',
                verticalAlign: 'bottom'
            },
            plotOptions: {
                series: { stacking: 'normal' },
                bar: { pointPadding: 0.2, borderWidth: 0, dataLabels: { enabled: false } }
            },
            series: [
                { type: 'bar', name: 'Day 0', data: [], color: this.colorArray[0] },
                { type: 'bar', name: 'Days 1-50', data: [], color: this.colorArray[1] },
                { type: 'bar', name: 'Days 51-75', data: [], color: this.colorArray[2] },
                { type: 'bar', name: 'Days 76-90', data: [], color: this.colorArray[3] },
                { type: 'bar', name: 'Days 91-168', data: [], color: this.colorArray[4] },
                { type: 'bar', name: 'Days 169-336', data: [], color: this.colorArray[5] },
                { type: 'bar', name: 'Unscheduled', data: [], color: this.colorArray[6] },
                { type: 'bar', name: 'Unknown', data: [], color: this.colorArray[7] }
            ]
        });
    }

    clickedSampleTypeByVisitChartLegend(index: number): void {

        if (this.samplesByVisitChart.series[index].visible) {
            this.samplesByVisitChart.series[index].hide();
            this.unitsByVisitChart.series[index].hide();
            $('.item' + index).addClass('inactive');
        }
        else {
            this.samplesByVisitChart.series[index].show();
            this.unitsByVisitChart.series[index].show();
            $('.item' + index).removeClass('inactive');
        }
    }
}
